(ns quuppa.peweb.notifications
  (:require [re-frame.core :as rf]
            ["react-transition-group/TransitionGroup" :default TransitionGroup]
            ["react-transition-group/CSSTransition" :default CSSTransition]))

(rf/reg-event-db :notifications/clear-notification
  (fn [db [_ id]]
    (update db :notifications dissoc id)))

(defn notification [{:keys [db]} [_ data]]
  (let [id   (or (:id data) (random-uuid))
        data (assoc data :id id)]
    {:db (update db :notifications assoc id data)
     :fx [(when (:timeout-ms data)
            [:dispatch-later {:ms       (:timeout-ms data)
                              :dispatch [:notifications/clear-notification id]}])]}))

(rf/reg-event-fx :notifications/notify
  notification)

(rf/reg-event-fx :notifications/notify-success
  (fn [cofx event-vec]
    (notification cofx (update event-vec 1 assoc :type :success :heading "Success" :timeout-ms (* 5 1000)))))

(rf/reg-sub ::notifications
  (fn [db]
    (vals (:notifications db))))

(rf/reg-sub ::notification
  (fn [db [_ id]]
    (get (:notifications db) id)))

(defmulti render-event-handler-error
  "When we have an :event-handler-error, let's check if it has 'subtype' in :ex-data."
  (fn [err] (get-in err [:ex-data :type])))

(defmethod render-event-handler-error :default
  [{:keys [ex-data event err-msg]}]
  [:span
   (or (:message ex-data)
       (str
         (if event
           (str "Error in event '" event "'")
           (str "Event error"))
         ", technical message: "
         (or (:reason-phrase ex-data) err-msg)))])

(defmethod render-event-handler-error :malli-error
  [{:keys [ex-data event]}]
  [:span
   (cond->> (pr-str (:malli-error ex-data))
     event (str event " => "))])

(defmethod render-event-handler-error :reitit.ring/response
  [{{:keys [response]} :ex-data}]
  [:span (:body response) " [" (:status response) "]"])

(defmulti render-message :type)

(defmethod render-message :default
  [{:keys [message]}]
  [:span message])

(defmethod render-message :error
  [{:keys [message]}]
  [:span message])

(defmethod render-message :event-handler-error
  [event-handler-error]
  (render-event-handler-error event-handler-error))

(defn render-notifications [& [{:keys [static-notifications]}]]
  (let [data @(rf/subscribe [::notifications])]
    [:div.notification-container
     [:> TransitionGroup
      {:component nil
       :appear true
       :exit true}
      ;; NOTE: Moving for loop contents to separate component breaks TransitionGroup,
      ;; because Reagent would create wrapper component that messes up TransitionGroups
      ;; way to set group item properties.
      (for [{:keys [id type heading] :as notification} (concat static-notifications data)]
        [:> CSSTransition
         {:key id
          :timeout 250
          :classNames "notification-fade"}
         [:div.alert
          {:role     "alert"
           :class    [(:class notification)                 ;; possible styling class for content
                      (or
                        (:alert-class notification)         ;; default alert class interpretation from :type can be overridden
                        (case type
                          (:error :event-handler-error) "alert-danger"
                          :success "alert-success"
                          :warning "alert-warning"
                          :secondary "alert-secondary"
                          "alert-primary"))]
           :on-click #(rf/dispatch [:notifications/clear-notification id])}
          (when heading
            [:h5.alert-heading heading])
          (render-message notification)]])]]))
